<template>
  <v-container>
    <v-dialog v-model="mensagensDialog" width="80%" fullscreen>
      <v-card color="#cccdcf">
        <v-toolbar color="primary" dark>
          <v-toolbar-title>{{ $t('homePassageiro.dialogs.messages.title') }}</v-toolbar-title>
          <v-spacer />
          <v-icon dark @click="closeMensagensDialog">mdi-close</v-icon>
        </v-toolbar>
        <v-card-text>
          <v-list height="80vh" style="overflow-y: auto; width: 100%; background-color: transparent;">
            <v-list-item v-for="(msg, m) in mensagens" :key="`${msg.id_mensagem}-${m}`" style="margin-bottom: 10px;">
              <mensagem-card
                :msg="msg"
                :color="msg.flag_mensagem_lida == 1 ? 'primary' : 'red'"
                :caption="msg.dt_envio_extenso"
                @click="marcarMensagem(msg)"
              />
            </v-list-item>
          </v-list>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn depressed color="transparent" @click="populaMensagensAntigas">
            {{ $t('homePassageiro.dialogs.messages.loadOldMessages') }}
          </v-btn>
          <v-spacer />
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-card>
      <v-card-title color="primary">
        <v-btn icon class="mr-2" :title="$t('guiasMotorista.backToGuides')" @click="goBack">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
        <div>{{ $t('homePassageiro.forms.personInfo.title') }}</div>
        <v-spacer />
        <v-badge color="error" overlap left>
          <template v-slot:badge>
            <span>{{ totalMensagensNovas }}</span>
          </template>
          <v-icon color="primary" style="margin-right: 10px;" large @click="openMensagensDialog">mdi-message-text</v-icon>
        </v-badge>
        <v-btn icon :title="$t('button.logout')" @click="logout">
          <v-icon>mdi-logout</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-form ref="formPessoa" v-model="formPessoaValidado">
          <v-row>
            <v-col cols="12" sm="8">
              <div class="text-h6">{{ nomeCompletoFormatado }}</div>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="8">
              <div class="text-subtitle-1">{{ pessoa.nome_grupo }}</div>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="8">
              <div class="text-subtitle-2">{{ pessoa.nome_situacao_ativa }}</div>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="8">
              <div class="text-subtitle-2">
                {{ $t('validationSituation.headers.situation') }}:
                {{ pessoa.nome_situacao_validacao || $t('validationSituation.notValidated') }}
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="4">
              <v-text-field
                v-model="pessoa.telefone"
                solo
                type="phone"
                v-mask="'(##) ## #####-####'"
                :label="$t('homePassageiro.forms.personInfo.fields.phone')"
                hint="(XX) XX XXXXX-XXXX"
                prepend-inner-icon="mdi-cellphone"
              />
            </v-col>
            <v-col cols="12" sm="4">
              <v-text-field
                v-model="pessoa.email"
                solo
                type="email"
                :label="$t('homePassageiro.forms.personInfo.fields.email')"
                :hint="$t('homePassageiro.forms.personInfo.fields.emailHint')"
                prepend-inner-icon="mdi-email"
              />
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn color="primary" dark :loading="savingPessoa" :disabled="!token || !pessoa.id_pessoa" @click="savePessoa">
          {{ $t('homePassageiro.forms.personInfo.save') }}
        </v-btn>
      </v-card-actions>
    </v-card>

    <v-card style="margin-top: 10px">
      <v-card-title color="primary">
        {{ $t('homePassageiro.forms.loginInfo.title') }}
      </v-card-title>
      <v-card-text>
        <v-form ref="formLogin" v-model="formLoginValidado">
          <v-row>
            <v-col cols="12" sm="4">
              <v-text-field outlined readonly :value="loginUsuario" :label="$t('homePassageiro.forms.loginInfo.fields.login')" disabled />
            </v-col>
            <v-col cols="12" sm="4">
              <v-text-field
                v-model="novaSenha"
                outlined
                :label="$t('homePassageiro.forms.loginInfo.fields.newPassword')"
                :append-icon="showSenha ? 'mdi-eye' : 'mdi-eye-off'"
                :type="showSenha ? 'text' : 'password'"
                :rules="[senhaRules]"
                autocomplete="new-password"
                @click:append="showSenha = !showSenha"
              />
            </v-col>
            <v-col cols="12" sm="4">
              <v-text-field
                v-model="repetirSenha"
                outlined
                :label="$t('homePassageiro.forms.loginInfo.fields.confirmPassword')"
                :append-icon="showRepetirSenha ? 'mdi-eye' : 'mdi-eye-off'"
                :type="showRepetirSenha ? 'text' : 'password'"
                :disabled="confirmarSenhaDisabled"
                :rules="[repetirSenhaRules]"
                autocomplete="new-password"
                @click:append="showRepetirSenha = !showRepetirSenha"
              />
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn color="primary" dark :loading="saving" :disabled="!token" @click="saveLogin">
          {{ $t('homePassageiro.forms.loginInfo.save') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
import apiController from '@/utils/apiController';
import DateUtils from '@/utils/dateutils';
import EventBus from '@/utils/eventBus';
import MensagemCard from './Cards/MensagemCard.vue';

export default {
  name: 'PerfilMotorista',
  components: {
    MensagemCard,
  },
  data() {
    return {
      token: null,
      idUsuario: null,
      loginUsuario: null,
      nomeUsuario: null,
      saving: false,
      savingPessoa: false,
      formLoginValidado: false,
      formPessoaValidado: false,
      novaSenha: null,
      repetirSenha: null,
      showSenha: false,
      showRepetirSenha: false,
      pessoa: {
        id_pessoa: null,
        nome_completo: null,
        nome_grupo: null,
        nome_situacao_ativa: null,
        nome_situacao_validacao: null,
        telefone: null,
        telefone_usuario: null,
        email: null,
        nome: null,
        sobrenome: null,
        cpf: null,
        id_grupo: null,
        matricula: null,
        contratado: null,
        id_turno: null,
      },
      mensagensDialog: false,
      mensagensAntigas: [],
      mensagensNovas: [],
      mensagensTimeout: null,
    };
  },
  computed: {
    totalMensagensNovas() {
      return this.mensagensNovas.length;
    },
    mensagens() {
      return [...this.mensagensNovas, ...this.mensagensAntigas];
    },
    confirmarSenhaDisabled() {
      return !this.novaSenha || this.novaSenha.length === 0;
    },
    nomeCompletoFormatado() {
      const base = this.pessoa && this.pessoa.nome_completo ? this.pessoa.nome_completo : this.nomeUsuario;
      if (!base) return null;

      let fNome = '';
      String(base)
        .split(' ')
        .forEach((s) => {
          if (!s) return;
          fNome += s.charAt(0).toUpperCase() + s.substring(1) + ' ';
        });
      return fNome.trim();
    },
  },
  created() {
    this.token = sessionStorage.getItem('api');
    const raw = sessionStorage.getItem('user');
    if (raw) {
      try {
        const u = JSON.parse(raw);
        this.idUsuario = u.id_usuario != null ? u.id_usuario : null;
        this.loginUsuario = u.login != null ? u.login : null;
        this.nomeUsuario = u.nome_usuario != null ? u.nome_usuario : null;
      } catch (e) {
        this.idUsuario = null;
        this.loginUsuario = null;
        this.nomeUsuario = null;
      }
    }

    this.loadPessoa();
  },
  beforeDestroy() {
    if (this.mensagensTimeout) {
      clearTimeout(this.mensagensTimeout);
      this.mensagensTimeout = null;
    }
  },
  methods: {
    goBack() {
      this.$router.push({ path: '/guiasmotorista/guias' });
    },
    formatTelefoneBR(raw) {
      if (!raw) return null;
      const digits = String(raw).replace(/\D/g, '');
      if (digits.length !== 11) return raw;
      return `(${digits.substring(0, 2)}) ${digits.substring(2, 3)} ${digits.substring(3, 7)}-${digits.substring(7)}`;
    },
    loadPessoa() {
      if (!this.token || !this.idUsuario) return;

      apiController.request(apiController.endpoints.getPessoaporusuario, {
        params: { id: this.idUsuario },
        onSuccess: (response) => {
          const row = Array.isArray(response.data) ? response.data[0] : null;
          this.pessoa = Object.assign({}, this.pessoa, row || {});
          const telUsuario = this.pessoa.telefone_usuario;
          const telPessoa = this.pessoa.telefone;
          const digitsU = telUsuario ? String(telUsuario).replace(/\D/g, '') : '';
          const rawTel = digitsU.length > 0 ? telUsuario : telPessoa;
          if (rawTel) {
            this.pessoa.telefone = this.formatTelefoneBR(rawTel);
          } else {
            this.pessoa.telefone = null;
          }
          if (this.pessoa.id_pessoa) {
            this.populaMensagensNovas();
          }
        },
      });
    },
    openMensagensDialog() {
      this.mensagensDialog = true;
    },
    closeMensagensDialog() {
      this.mensagensDialog = false;
    },
    populaMensagensNovas() {
      if (!this.token || !this.pessoa || !this.pessoa.id_pessoa) return;

      apiController.request(apiController.endpoints.getMensagensnaolidaspordestinatario, {
        params: { id: this.pessoa.id_pessoa },
        onSuccess: (response) => {
          this.mensagensNovas = response.data;
          if (this.mensagensTimeout) {
            clearTimeout(this.mensagensTimeout);
          }
          this.mensagensTimeout = setTimeout(this.populaMensagensNovas, 60000);
        },
      });
    },
    populaMensagensAntigas() {
      if (!this.token || !this.pessoa || !this.pessoa.id_pessoa) return;

      let dt;
      if (this.mensagensAntigas.length === 0) {
        dt = DateUtils.getDateSQLFormatted(new Date());
      } else {
        dt = this.mensagensAntigas[this.mensagensAntigas.length - 1].dt_envio;
      }

      apiController.request(apiController.endpoints.getMensagenspordestinatariolazy, {
        params: { id: this.pessoa.id_pessoa, dt },
        onSuccess: (response) => {
          if (response.data.length > 0) {
            response.data.forEach((m) => {
              if (this.mensagensNovas.findIndex((e) => e.id_envio == m.id_envio) === -1) {
                this.mensagensAntigas.push(...response.data);
              }
            });
          }
        },
      });
    },
    marcarMensagem(msg) {
      msg.flag_mensagem_lida = 1;

      apiController.request(apiController.endpoints.updateEnviomensagem, {
        data: msg,
        onSuccess: () => {
          this.populaMensagensNovas();
        },
      });
    },
    resetLoginForm() {
      this.showSenha = false;
      this.showRepetirSenha = false;
      this.novaSenha = null;
      this.repetirSenha = null;
      if (this.$refs.formLogin) {
        this.$refs.formLogin.resetValidation();
      }
    },
    savePessoa() {
      if (!this.$refs.formPessoa) return;
      this.$refs.formPessoa.validate();
      if (!this.formPessoaValidado) return;

      if (!this.token || !this.pessoa || !this.pessoa.id_pessoa) {
        EventBus.$emit('show-error', {
          error: {
            message: this.$t('system.messages.accessDenied'),
            response: { status: 401 },
          },
        });
        return;
      }

      const payload = { ...this.pessoa };
      delete payload.telefone_usuario;
      if (payload.telefone) {
        payload.telefone = String(payload.telefone).replace(/\D/g, '');
      }

      this.savingPessoa = true;
      apiController.request(apiController.endpoints.updatePessoa, {
        data: payload,
        onSuccess: (response) => {
          const data = response && response.data ? response.data : {};
          EventBus.$emit('show-alert', {
            mensagem: data.mensagem,
            tipo: data.erro ? 'error' : 'success',
          });
          if (!data.erro) {
            if (this.$refs.formPessoa) this.$refs.formPessoa.resetValidation();
            this.loadPessoa();
          }
          this.savingPessoa = false;
        },
        onError: () => {
          this.savingPessoa = false;
        },
      });
    },
    saveLogin() {
      if (!this.$refs.formLogin) return;
      this.$refs.formLogin.validate();
      if (!this.formLoginValidado) return;

      if (this.idUsuario == null || !this.token) {
        EventBus.$emit('show-error', {
          error: {
            message: this.$t('system.messages.accessDenied'),
            response: { status: 401 },
          },
        });
        return;
      }

      this.saving = true;
      apiController.request(apiController.endpoints.alteraSenha, {
        data: {
          id_usuario: this.idUsuario,
          senha: this.novaSenha,
          repetirsenha: this.repetirSenha,
        },
        onSuccess: (response) => {
          const data = response && response.data ? response.data : {};
          EventBus.$emit('show-alert', {
            mensagem: data.mensagem || (data.erro ? this.$t('system.messages.changePasswordError') : this.$t('system.messages.changePasswordSuccess')),
            tipo: data.erro ? 'error' : 'success',
          });
          if (!data.erro) this.resetLoginForm();
          this.saving = false;
        },
        onError: () => {
          this.saving = false;
        },
      });
    },
    senhaRules() {
      if (!this.novaSenha || this.novaSenha.length === 0) {
        return this.$t('homePassageiro.validation.passwordRequired');
      }
      if (!/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[$*&@#])[0-9a-zA-Z$*&@#]{8,}$/.test(this.novaSenha)) {
        return this.$t('homePassageiro.validation.passwordComplexity');
      }
      return true;
    },
    repetirSenhaRules() {
      if (this.novaSenha !== this.repetirSenha) {
        return this.$t('homePassageiro.validation.passwordsNotMatch');
      }
      return true;
    },
    logout() {
      const raw = sessionStorage.getItem('user');
      let registro = { id_usuario: -1, logado: 0, token: null };
      if (raw) {
        try {
          const u = JSON.parse(raw);
          if (u && u.id_usuario != null) {
            registro = { id_usuario: u.id_usuario, logado: 0, token: null };
          }
        } catch (e) {
          /* ignore */
        }
      }
      apiController.request(apiController.endpoints.atualizastatus, {
        data: registro,
        silent: true,
        onSuccess: () => {
          sessionStorage.removeItem('user');
          sessionStorage.removeItem('api');
          sessionStorage.removeItem('permissoes');
          this.$router.push({ path: '/' });
        },
        onError: () => {
          sessionStorage.removeItem('user');
          sessionStorage.removeItem('api');
          sessionStorage.removeItem('permissoes');
          this.$router.push({ path: '/' });
        },
      });
    },
  },
};
</script>
